const smoothScroll = require("smoothscroll");

export default class PaymentNewConcept {
  constructor(args) {
    console.log('payment_new_concept.js loaded');

    // select section
    let payementHeaders = document.querySelectorAll('.payment--main--header');
    for (let i = 0; i < payementHeaders.length; i++) {
      let elem = payementHeaders[i];
      let elemParent = elem.parentElement;
      let id = elem.getAttribute('id');

      if (!elemParent.classList.contains('is-disabled')) {
        elem.onclick = () => {
          for (let i = 0; i < payementHeaders.length; i++) {
            let elem = payementHeaders[i];
            let id = elem.getAttribute('id');
            elem.parentElement.classList.remove('is-selected');
            document.getElementById(id + '_content').classList.remove('is-active');
          }

          elemParent.classList.toggle('is-selected');
          document.getElementById(id + '_content').classList.toggle('is-active');

          setTimeout(function(){ smoothScroll(elem); }, 200);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./pages/payment_new_concept.js